import { StoreOfferProduct } from '@common'
import cx from 'classnames'
import Image from 'next/image'
import { useTranslations } from 'next-intl'

import ItemBg from '@/assets/images/campaigns/item-bg-with-points.png'
import { useBreakpoints } from '@/utils/useBreakpoints'

import { resolveProductImage } from '../../../../utils/resolveProductImage'
import { snowplowTrackCampaign } from '../../../../utils/snowplow'
import { BuyButton } from '../BuyButton/BuyButton'
import { CardBase } from '../card/CardBase'
import { StoreTypography } from '../typography/StoreTypography'

import styles from './Campaign.module.scss'
import storeStyles from '../storefronts.module.scss'

interface CampaignProps {
  product: StoreOfferProduct
}

const CampaignProduct = ({ product }: CampaignProps) => {
  return (
    <CardBase className={cx(styles.campaignProduct, styles['clashofclans'])}>
      <div className={styles.header}>
        <Image
          className={styles.headerImage}
          src={ItemBg}
          alt="campaign-item-background"
          fill
          sizes="(max-width: 600px) 400px, 600px"
          quality={100}
          style={{ objectFit: 'contain' }}
        />
        <div className={styles.logoContainer}>
          <div className={styles.logoImageContainer}>
            <Image
              className={styles.logo}
              src={resolveProductImage(product)}
              fill
              sizes="(max-width: 500px) 300px, 400px"
              alt="passcard icon"
              placeholder="empty"
            />
          </div>
        </div>
      </div>
    </CardBase>
  )
}

export const Campaign = ({ product }: CampaignProps) => {
  const { from } = useBreakpoints()
  const t = useTranslations()
  const isDesktop = from('tablet')

  const typography = {
    tag: 'p',
    style: 'plain',
    textSize: isDesktop ? 'md' : 'body',
    overrideFont: 'supercellText',
    lineHeight: 'normal',
  } as const

  return (
    <div className={cx(styles.campaign, storeStyles.topOverlap, storeStyles.bottomOverlap)}>
      <div id="campaign" className={styles.campaigHeading}>
        <div className={styles.title}>
          <StoreTypography className={styles.titleText} tag="h1" textSize={isDesktop ? 'xl' : 'lg'} style="outlined">
            {t('campaign_title')}
          </StoreTypography>
        </div>
      </div>
      <div className={styles.productContainer}>
        <CampaignProduct key={product.id} product={product} />
      </div>
      <div className={styles.description}>
        <StoreTypography className={styles.titleText} {...typography}>
          {t('buy_pass_helper_text')}
        </StoreTypography>
        <div className={styles.campaignBuyButton}>
          <BuyButton product={product} onAddToCart={() => snowplowTrackCampaign('goldPass')} />
        </div>
      </div>
    </div>
  )
}
